import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'EditorialHeadingParagraph',
})(({ spacing, brandColors }, props) => ({
  container: {
    padding: `${spacing(0)} 0`,
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  spacer: {
    paddingTop: spacing(5),
  },
  heading: {
    marginBottom: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  textColor: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  embeddedContent: {
    margin: `${spacing(2)} 0`,
  },
}));

export default useStyles;
